import React from 'react';
import {useTranslation} from 'react-i18next';

const gameRebateImg = require('@/assets/imgs/Gmme-Rebate.webp');

export const GameRebateFooter: React.FC = () => {
  const {t} = useTranslation();

  return (
    <div className="relative min-h-[5.6875rem] overflow-hidden px-2 pb-[0.8125rem] pt-2">
      <div className="relative z-[1] h-[4.375rem] w-[16.1875rem] break-words font-['Inter'] text-[0.625rem] font-normal leading-[0.875rem] text-[#989898]">
        <p className="mb-0">
          {t('invitation.home.game-rebate-design-description-pick11')}
        </p>
        <p className="mb-0">
          {t('invitation.home.game-rebate-design-description-rummy')}
        </p>
      </div>
      <img
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute right-[0.04375rem] top-[0.4375rem] h-[4.026rem] w-[5.625rem] max-w-none object-cover shadow-[0_0.25rem_0.25rem_0_rgba(0,0,0,0.25)]"
        src={gameRebateImg}
      />
    </div>
  );
};
